/** @typedef {import('../types/finance').Dispute} Dispute */
/** @typedef {import('../types/api').PaginatedResponse} PaginatedResponse */
/** @typedef {import('../types/api').PaginationParams} PaginationParams */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { API_LIMIT, instance, IS_ADMIN } from '../config';

/**
 * @param {PaginationParams} params
 * @returns {Promise<PaginatedResponse<Dispute>>}
 */
const fetchDisputes = async ({ offset, searchQuery, status, dateFilter }) => {
  const { from, to } = dateFilter;
  const { data } = await instance.get(
    `disputes${!IS_ADMIN ? '/merchant' : ''}?limit=${API_LIMIT}${
      offset ? '&offset=' + offset : ''
    }${searchQuery ? '&search_term=' + searchQuery : ''}${status ? '&status=' + status : ''}${
      from && to ? '&from=' + from + '&to=' + to : ''
    }`
  );
  return data;
};

/**
 * @param {{ reference: string, status: string }} params
 * @returns {Promise<ApiResponse<Object>>}
 */
const processDispute = async ({ reference, status }) => {
  const { data } = await instance.patch(`dispute/process/${reference}`, {
    status: status
  });

  return data;
};

export { fetchDisputes, processDispute };
